import { post, get, patch, deleteRequest, patchBlob } from './restApi';


export const getDetailsProcecssingStatusCalibrationWork = (payload) => {
    return patch('reportCalibrationWork/get-details-procecssing-status-calibration-work', { ...payload });
}
export const getSumaryProcecssingStatusCalibrationWork = (payload) => {
    return patch('reportCalibrationWork/get-summary-procecssing-status-calibration-work', { ...payload });
}
export const getDetailsReportEngineerPerformanceInCalibrationWork = (payload) => {
    return patch('reportCalibrationWork/get-details-report-enginee-performancein-calibration-work', { ...payload });
}
export const getSummaryReportEngineerPerformanceInCalibrationWork = (payload) => {
    return patch('reportCalibrationWork/get-summary-report-enginee-performancein-calibration-work', { ...payload });
}
export const getSumaryProcecssingStatusCalibrationWorkExcel = (payload) => {
    return patchBlob('reportCalibrationWork/get-summary-procecssing-status-calibration-work-excel', { ...payload });
}
export const getDetailsProcecssingStatusCalibrationWorkExcel = (payload) => {
    return patchBlob('reportCalibrationWork/get-details-procecssing-status-calibration-work-excel', { ...payload });
}
export const getSumaryReportEngineerPerformanceInCalibrationWorkExcel = (payload) => {
    return patchBlob('reportCalibrationWork/get-summary-report-enginee-performancein-calibration-work-excel', { ...payload });
}
export const getDetailsReportEngineerPerformanceInCalibrationWorkExcel = (payload) => {
    return patchBlob('reportCalibrationWork/get-details-report-enginee-performancein-calibration-work-excel', { ...payload });
}